/**
 * @generated SignedSource<<cdd61b0777d7396674d96ea48cb1d7db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ThumbVideo_viewer$data = {
  readonly video: {
    readonly fileByVideoSize: {
      readonly link: string | null;
    } | null;
    readonly height: number | null;
    readonly videoThumb: string | null;
    readonly width: number | null;
  } | null;
  readonly " $fragmentType": "ThumbVideo_viewer";
};
export type ThumbVideo_viewer$key = {
  readonly " $data"?: ThumbVideo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ThumbVideo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./ThumbVideoRefetchQuery.graphql')
    }
  },
  "name": "ThumbVideo_viewer",
  "selections": [
    {
      "alias": "video",
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        }
      ],
      "concreteType": "VideoVimeo",
      "kind": "LinkedField",
      "name": "itemVideo",
      "plural": false,
      "selections": [
        {
          "alias": "videoThumb",
          "args": [
            {
              "kind": "Literal",
              "name": "pad",
              "value": false
            },
            {
              "kind": "Literal",
              "name": "size",
              "value": "w295h166"
            }
          ],
          "kind": "ScalarField",
          "name": "thumbnail",
          "storageKey": "thumbnail(pad:false,size:\"w295h166\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VideoVimeoFile",
          "kind": "LinkedField",
          "name": "fileByVideoSize",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "06f5213bca531e9846ca0bf8469c889e";

export default node;
